export type TransactionTabId = 'transactions' | 'ap-payments' | 'ap-statement' | 'ap-aging' | 'ap-variance';

export interface TransactionTab {
  id: TransactionTabId;
  labelKey: string;
  icon: string;
}

export const TRANSACTION_TABS: readonly TransactionTab[] = [
  { id: 'transactions', labelKey: 'transactions.title', icon: 'fas fa-money-bill-transfer' },
  {
    id: 'ap-payments',
    labelKey: 'accountsPayable.payments.tab',
    icon: 'fas fa-file-invoice-dollar',
  },
];

export const AP_TRANSACTION_TABS: readonly TransactionTab[] = [
  { id: 'ap-payments', labelKey: 'accountsPayable.payments.sectionTab', icon: 'fas fa-money-bill' },
  { id: 'ap-statement', labelKey: 'accountsPayable.statement.tab', icon: 'fas fa-file-lines' },
  { id: 'ap-aging', labelKey: 'accountsPayable.aging.tab', icon: 'fas fa-hourglass-half' },
  { id: 'ap-variance', labelKey: 'accountsPayable.variance.tab', icon: 'fas fa-scale-unbalanced' },
];

export const TRANSACTION_TAB_IDS: readonly TransactionTabId[] = [
  TRANSACTION_TABS[0].id,
  ...AP_TRANSACTION_TABS.map((tab) => tab.id),
];

export const AP_TRANSACTION_TAB_IDS: readonly TransactionTabId[] =
  TRANSACTION_TAB_IDS.filter((id) => id !== 'transactions');

export function toTransactionTabId(value: string | null | undefined): TransactionTabId {
  return TRANSACTION_TAB_IDS.find((id) => id === value) ?? 'transactions';
}
